export interface IManifest {
  endpoints: {
    userInfo: string;
    playerConfig: string;
    casinoConfig: string;
    tableConfig: string;
  };
  useGtag: boolean;
}

/*
 * # Manifest Supplier
 *
 * A singleton class that provides the manifest object, handles amendment of the manifest object and provides a method to retrieve the manifest object.
 * */
export class CoreManifestSupplierClass {
  private static instance: CoreManifestSupplierClass;

  private manifest: IManifest = {
    endpoints: {
      userInfo: ENDPOINT_USER_INFO,
      playerConfig: ENDPOINT_PLAYER_CONFIG,
      casinoConfig: ENDPOINT_CASINO_CONFIG,
      tableConfig: ENDPOINT_TABLE_CONFIG,
    },
    useGtag: USE_GTAG,
  };

  public static getInstance(): CoreManifestSupplierClass {
    if (!CoreManifestSupplierClass.instance) {
      CoreManifestSupplierClass.instance = new CoreManifestSupplierClass();
    }
    return CoreManifestSupplierClass.instance;
  }

  getManifest(): IManifest {
    return this.manifest;
  }
}

export const CoreManifestSupplier = CoreManifestSupplierClass.getInstance();

export const CoreManifest = CoreManifestSupplier.getManifest();
